module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/kimono/hikifuri-4520697567fc426ee208ea72befb77ed.jpg";